// Thread attachments need to be trimmed to less than1MB
export const trimThreadAttachment = (str: string): string => {
  const encoder = new TextEncoder(); // UTF-8 encoder
  const bytes = encoder.encode(str);

  if (bytes.length < 1024 * 1024 - 4) {
    return str;
  }

  // Binary search to find the max substring that fits under 1MB
  let left = 0;
  let right = str.length;
  let result = "";

  while (left < right) {
    const mid = Math.floor((left + right) / 2);
    const sub = str.substring(0, mid);
    const subBytes = encoder.encode(sub);

    if (subBytes.length < 1024 * 1024 - 4) {
      result = sub;
      left = mid + 1;
    } else {
      right = mid;
    }
  }

  return result;
};
